export default __webpack_public_path__ + "static/media/2-blop.2efdfe96.png";